export enum BackgroundTaskStatusEnum {
    Queued = 1,
    Inprogress = 2,
    Failure = 3,
    Completed = 4
}